/** The levels the idea names a meaning for; the others are steps between them. */
export const LANDMARKS: Record<number, string> = {
    1: 'start learning',
    9: 'middle+',
    10: 'senior',
    12: 'expert',
};

/** Karate belt colours by level: white to purple through the first Kyu grades, brown to Kyu 1, black for Dan. */
const BELT_COLORS: Record<number, string> = {
    1: '#FFFFFF',
    2: '#FFD54A',
    3: '#FF9F43',
    4: '#3CB44B',
    5: '#2E86DE',
    6: '#8E5CD9',
    7: '#8B5A2B',
    8: '#8B5A2B',
    9: '#6D4520',
};

export function beltColor(level: number): string {
    return BELT_COLORS[level] ?? '#161C24';
}
